module.exports = __webpack_public_path__ + "img/back.f9a2d4ba.jpg";